import SrNavPage from "./index.vue";

SrNavPage.install = function(Vue) {
  Vue.component(SrNavPage.name, SrNavPage);
};

export default SrNavPage;



// WEBPACK FOOTER //
// ./packages/SrNavPage/index.js